import { FETCH_BRANCHLIST_FAILURE, FETCH_BRANCHLIST_REQUEST, FETCH_BRANCHLIST_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const posBranchListReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BRANCHLIST_REQUEST:
            return {
                ...state,
            }
        case FETCH_BRANCHLIST_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_BRANCHLIST_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}